export default __webpack_public_path__ + "static/media/informacion.c7f76b9d.png";